import { useState } from 'react';

import { Button } from 'primereact/button';

import type { ScheduledSemenResponse } from '@/services/semen-pull/types';

import { UpdateSemenDialog } from '../dialogs/UpdateSemenDialog';
import { useSemenPullContext } from '../useSemenPullContext';

type Props = {
  data: ScheduledSemenResponse;
};
export const UpdateSemenButton = ({ data }: Props) => {
  const { setCurrentScheduledSemen } = useSemenPullContext();
  const [updateSemenDialogVisible, setUpdateSemenDialogVisible] =
    useState(false);
  return (
    <>
      <Button
        size="small"
        icon="pi pi-pencil"
        rounded
        text
        onClick={() => {
          setUpdateSemenDialogVisible(true);
          setCurrentScheduledSemen(() => data);
        }}
      ></Button>
      {updateSemenDialogVisible && (
        <UpdateSemenDialog
          updateSemenDialogVisible={updateSemenDialogVisible}
          setUpdateSemenDialogVisible={setUpdateSemenDialogVisible}
        ></UpdateSemenDialog>
      )}
    </>
  );
};
